import { ref, computed, watch } from 'vue';
import store from '@/store';
import { useUbicacion } from '@/composables/front/common/useUbicacion';
import { formatearFecha } from '@/composables/front/formatters/useFilters';

export function useDatosPersonalesForm({ userData, perfilState, observer, emit }) {
    const {
        isEditing,
        localData,
        loading,
        errors,
        startEditing,
        cancelEditing,
        save,
    } = perfilState;

    const {
        paises, provincias, localidades,
        loadingPaises, loadingProvincias, loadingLocalidades,
        paisId, provinciaId, localidadId,
        esEspana,
        seleccionarPais, seleccionarProvincia, seleccionarLocalidad,
        inicializar,
    } = useUbicacion();

    const generos = computed(() => store.getters.getGeneros);

    const generoId = computed({
        get: () => localData.value.genero?.id ?? null,
        set: val => {
            const generoSeleccionado = store.getters.getGeneros?.find(g => g.id === val) ?? null;
            localData.value.genero = generoSeleccionado ? { id: generoSeleccionado.id, name: generoSeleccionado.name } : { id: val };
        }
    });

    const fechaNacimientoFormateada = computed(() => formatearFecha(userData.value?.fecha_nacimiento));

    watch(paisId, val => {
        if (!localData.value.pais) localData.value.pais = {};
        localData.value.pais.id = val;
        localData.value.provincia = null;
        localData.value.localidad = null;
    });

    watch(provinciaId, val => {
        if (!localData.value.provincia) localData.value.provincia = {};
        localData.value.provincia.id = val;
        localData.value.localidad = null;
    });

    watch(localidadId, val => {
        if (!localData.value.localidad) localData.value.localidad = {};
        localData.value.localidad.id = val;
    });

    watch(isEditing, async editing => {
        if (!editing) return;
        await inicializar(
            localData.value.pais?.id ?? null,
            localData.value.provincia?.id ?? null,
            localData.value.localidad?.id ?? null,
        );
    });

    watch(() => userData.value, newData => {
        if (!isEditing.value) {
            localData.value = { ...newData };
        }
    }, { deep: true });

    const telefonoFormateado = computed(() => {
        const tel = userData.value?.telefono;
        if (!tel) return '-';
        const str = String(tel);
        return str.startsWith('34') && str.length > 2
            ? `+34 ${str.slice(2)}`
            : tel;
    });

    const submitted = ref(false);
    const phoneIsValid = ref(!!userData.value?.telefono);

    const handleSave = async() => {
        submitted.value = true;
        if (!phoneIsValid.value) return;
        const result = await save(() => observer.value?.validate());
        if (result?.success) {
            submitted.value = false;
            emit('saved');
        }
    };

    const handleCancel = () => {
        submitted.value = false;
        cancelEditing();
    };

    return {
        isEditing,
        localData,
        loading,
        errors,
        startEditing,
        paises, provincias, localidades,
        loadingPaises, loadingProvincias, loadingLocalidades,
        paisId, provinciaId, localidadId,
        esEspana,
        seleccionarPais, seleccionarProvincia, seleccionarLocalidad,
        generos,
        generoId,
        fechaNacimientoFormateada,
        telefonoFormateado,
        submitted,
        phoneIsValid,
        handleSave,
        handleCancel,
    };
}
